import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTeacherPayoutRequest = createSelector([(state: AppState) => state.teacher.payoutRequest], state => state);
